'use strict';

const $ = window.jQuery;

export default class StickyHeader {
    constructor() {
        if ($(window).scrollTop() > 60) {
            $('#header, body').addClass('is-sticky');
        };

        $(window).on('scroll', function () {
            let scroll = $(window).scrollTop();

            if (scroll > 60) {
                $('#header, body').addClass('is-sticky');
            } else {
                $('#header, body').removeClass('is-sticky');
            }
        });
    }
}
